import { Tabs } from 'src/components';
import { Color } from 'src/constants';

export const OVERVIEW_PATH = '/projects';
export const ACTIVITY_PATH = '/projects/activity';

type Props = {
  selected: 'overview' | 'activity';
};

export default function ProjectsTabs({ selected }: Props) {
  return (
    <Tabs
      accentColor={Color.accent}
      tabs={[
        {
          label: 'Project Overview',
          to: OVERVIEW_PATH,
          selected: selected === 'overview',
        },
        {
          label: 'Daily Activity',
          to: ACTIVITY_PATH,
          selected: selected === 'activity',
        },
      ]}
    />
  );
}
